// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__Lout5","logoPlaceholder":"style__logoPlaceholder__qHeT9"};